import { FileExplorerItem } from '@features/file-explorer/types'

/**
 * Creates a click handler for item links that intercepts normal clicks
 * but allows browser default behavior for modifier clicks (Ctrl+Click, middle-click, etc.)
 */
export function createItemClickHandler(
  item: FileExplorerItem,
  onItemClick: (item: FileExplorerItem) => void
) {
  return (e: React.MouseEvent) => {
    // Only intercept normal left-clicks without modifiers
    if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
      e.preventDefault()
      e.stopPropagation()
      onItemClick(item)
    }
    // Let browser handle Ctrl+Click, middle-click, etc naturally
  }
}
